import React from 'react';
export const DiscoverySection = () => {
  return <section className="w-full py-20 bg-gradient-to-b from-yellow-600 via-yellow-500 to-yellow-400" data-id="element-71">
      <div className="max-w-4xl mx-auto px-4" data-id="element-72">
        <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-73">
          ODKRYCIE MECHANIZMU
        </h2>
        <div className="bg-white rounded-xl shadow-2xl p-8 mb-12" data-id="element-74">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-8 text-gray-800" data-id="element-75">
            BŁĘDNE KOŁO EMOCJONALNEGO ODRZUCENIA
          </h3>
          <div className="w-64 h-64 md:w-80 md:h-80 mx-auto relative" data-id="element-76">
            <div className="absolute inset-0 rounded-full border-4 border-yellow-500" data-id="element-77"></div>
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-yellow-500 text-white font-bold py-2 px-4 rounded-full" data-id="element-78">
              Ona się STARA
            </div>
            <div className="absolute right-0 top-1/2 translate-x-1/2 -translate-y-1/2 bg-yellow-500 text-white font-bold py-2 px-4 rounded-full" data-id="element-79">
              On się WYCOFUJE
            </div>
            <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 bg-yellow-500 text-white font-bold py-2 px-4 rounded-full" data-id="element-80">
              Ona się STARA BARDZIEJ
            </div>
            <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-yellow-500 text-white font-bold py-2 px-4 rounded-full" data-id="element-81">
              On UCIEKA
            </div>
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-82">
              <svg className="w-16 h-16 text-yellow-500 animate-spin-slow" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-83">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" data-id="element-84"></path>
              </svg>
            </div>
          </div>
        </div>
        <div className="text-center mt-12" data-id="element-85">
          <div className="bg-red-100 p-6 rounded-lg inline-block shadow-lg" data-id="element-86">
            <p className="text-xl md:text-2xl font-serif text-red-800" data-id="element-87">
              "Polskie kobiety w pułapce 'superżony'"
            </p>
          </div>
          <div className="mt-8 bg-gray-900 text-white p-6 rounded-lg shadow-lg" data-id="element-88">
            <p className="text-xl md:text-2xl font-bold" data-id="element-89">
              "Im więcej dajesz, tym mniej jesteś kochana"
            </p>
          </div>
          <div className="mt-8 bg-white text-gray-800 p-6 rounded-lg shadow-lg" data-id="element-90">
            <p className="text-xl md:text-2xl font-serif" data-id="element-91">
              "Nie byłam złą żoną. Byłam uwięziona w błędnym systemie."
            </p>
          </div>
        </div>
      </div>
    </section>;
};